import Fuse from 'fuse.js';

import { OccupationsListItem } from '~/types/refData';
import FuseSearchOptions = Fuse.FuseSearchOptions;

export const createOccupationSearcher = (occupations: OccupationsListItem[]) => {
  const fuse = new Fuse(occupations, {
    keys: [
      {
        name: 'desc',
        weight: 0.8,
      },
      {
        name: 'anzsicShortDescription',
        weight: 0.2,
      },
    ],
    threshold: 0.1,
    includeMatches: true,
  });

  return (pattern: string, options?: FuseSearchOptions) => fuse.search(pattern, options);
};
